module.exports = __webpack_public_path__ + "static/img/rank_258.20b97fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_258.png
// module id = Z/Ln
// module chunks = 1